import { useState } from "react";
import {
  Button,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "../../../components";

const FiltroCustom = ({
  sendServer,
  enviarServicosPendentes,
  permissaoWhatsappAvancado,
}) => {
  const [filtros, setFiltros] = useState({
    orderBy: "updatedAt",
    order: "desc",
    page: "1",
    restritiva: true,
  });

  const listaStatus = [
    {
      value: "PROXIMO",
      label: "Próximos",
      cor: "#fe9a00",
    },
    {
      value: "ATRASADO",
      label: "Atrasados",
      cor: "#e62b34",
    },
    {
      value: "NOTIFICADO",
      label: "Notificados",
      cor: "#008b5b",
    },
    {
      value: "AGENDADO",
      label: "Agendados",
      cor: "#1769aa",
    },
    {
      value: "REALIZADO",
      label: "Realizados",
      cor: "#d3e1e2",
    },
  ];

  const pesquisar = (e) => {
    e.preventDefault();
    filtros.page = "1";
    sendServer({ tipoFiltro: "simples", filtros });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFiltros((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "status") {
      const filtrosTemp = {
        ...filtros,
        status: value,
      };
      sendServer({ tipoFiltro: "simples", filtros: filtrosTemp });
    }
  };

  return (
    <div className="d-flex flex-row align-items-stretch mt-1 mb-2 w-100">
      <form onSubmit={(e) => pesquisar(e)}>
        <TextField
          id="pesquisar"
          name="cliente"
          label="Pesquisar por Cliente"
          fullWidth
          value={filtros?.cliente}
          margin="normal"
          onChange={handleInputChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={pesquisar}>
                  <i
                    className="ph-bold ph-magnifying-glass"
                    style={{ color: "#494C62", fontSize: 18 }}
                  ></i>
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </form>
      <div className="px-2 ms-1">
        <Select
          id="status"
          name="status"
          value={filtros?.status || "TODOS"}
          label="Status"
          margin="normal"
          fullWidth
          disableClearable
          onChange={handleInputChange}
        >
          <MenuItem value={"TODOS"}>Todos os status</MenuItem>
          {listaStatus.map((status, index) => (
            <MenuItem key={index} value={status.value}>
              <i
                className="ph-fill ph-circle"
                style={{
                  color: `${status.cor}`,
                  verticalAlign: "middle",
                  marginRight: 4,
                }}
              ></i>
              &nbsp;{status.label}
            </MenuItem>
          ))}
        </Select>
      </div>
      {permissaoWhatsappAvancado && (
        <div className="ms-auto d-flex flex-column justify-content-end py-2 ps-2 mt-2">
          <Button
            variant="contained"
            color="primary"
            disableElevation
            onClick={enviarServicosPendentes}
            sx={{
              textTransform: "none",
              padding: "6px 14px",
              backgroundColor: "#fdf9fa",
              border: "1px solid #d3d3d3",
              borderRadius: "10px",
              "&:hover": {
                backgroundColor: "#008b5bc7",
                border: "1px solid #008b5b33",
                "& .ph-fill": {
                  color: "#fcfcfc !important",
                },
                "& .MuiTypography-root": {
                  color: "#fcfcfc",
                },
              },
            }}
          >
            <i
              className={`ph-fill ph-chat-circle`}
              style={{
                fontSize: 18,
                marginRight: 7,
                color: "#001718",
              }}
            ></i>
            <Typography
              sx={{ fontSize: 13, fontWeight: "600", color: "#001718" }}
            >
              Notificar Todos
            </Typography>
          </Button>
        </div>
      )}
    </div>
  );
};

export default FiltroCustom;
